<template>
  <div class="flex">
    <div class="w-256 mr-16">
      <h3 class="text-overline mb-4">Type</h3>
      <p class="text-body text-left mb-16">One time sitter</p>
      <h3 class="text-overline mb-4">Start Date</h3>
      <p class="text-body text-left mb-16">{{ formattedStartDate }}</p>
      <h3 class="text-overline mb-4">Time</h3>
      <p data-testid="time" class="text-body text-left">{{ timeFrame }}</p>
      <p v-if="startTimeFlexible" id="start-time-flexible" class="text-body text-left italic">Start time is flexible</p>
      <p data-testid="duration" class="text-body text-left italic mb-16">Duration: {{ duration }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { timeframe as buildTimeframe, duration as calculateDuration } from '@/lib/time';

export default {
  name: 'JobPostScheduleOneTimeReview',
  props: {
    formattedStartDate: {
      type: String,
      required: true,
    },
    startTime: {
      type: Date as PropType<Date>,
      required: true,
    },
    endTime: {
      type: Date as PropType<Date>,
      required: true,
    },
    startTimeFlexible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    duration(): string {
      if (this.startTime && this.endTime) {
        return calculateDuration(this.startTime, this.endTime);
      }

      return '';
    },
    timeFrame(): String {
      if (this.startTime && this.endTime) {
        return buildTimeframe(this.startTime, this.endTime);
      }

      return '';
    },
  },
};
</script>
